<template>
    <SelectField
        v-model="selected.sort"
        @change="sort(selected.sort)"
        :input-classes="
            selected.sort
                ? 'text-bold select-filter-mobile text-uppercase'
                : 'select-filter-mobile text-uppercase'
        "
        :class="{ show }"
    >
        <option v-for="option in sortOptions" :key="option.value" v-bind:value="option.value">
            {{ option.label }}
        </option>
    </SelectField>
</template>

<script>
    import CatalogSort from './CatalogSort';
    import SelectField from '../../../../../submodules/src/components/input/select-field/SelectField.vue';

    export default {
        name: 'CatalogSortSelectMobile',

        extends: CatalogSort,
        components: {
            SelectField,
        },

        props: {
            show: Boolean,
        },
    };
</script>
